const r = "dsErrorBanner";
export {
  r as errorBannerKey
};
//# sourceMappingURL=design-system.es12.js.map
